import _objectSpread from "/var/lib/jenkins/workspace/enrich-prod-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import * as React from 'react';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
export default (function (className) {
  return /*#__PURE__*/React.forwardRef(function (p, ref) {
    return /*#__PURE__*/_jsx("div", _objectSpread({}, p, {
      ref: ref,
      className: classNames(p.className, className)
    }));
  });
});